"use client";
import { motion, useReducedMotion } from "framer-motion";
import { IconBrandAmazon } from "@/lib/tabler-icons";
import Link from "next/link";
import Image from "next/image";

interface BookProps {
	className?: string;
	showInfo?: boolean;
	showAmazonLink?: boolean;
	amazonUrl?: string;
}

export default function Book({
	className = "",
	showInfo = true,
	showAmazonLink = true,
	amazonUrl = "https://www.amazon.com/-/es/ARANZAZU-G-BUTLER-ebook/dp/B0F8JRBP1Y",
}: BookProps) {
	// Aspect ratio del libro real: 281:444.917 ≈ 1:1.58
	// Tamaños fijos: mobile (w-48) y web (w-64)
	const prefersReducedMotion = useReducedMotion();

	return (
		<div className={`relative ${className} `}>
			{/* Contenedor principal del libro */}
			<div className="relative transform rotate-3 hover:rotate-0 transition-transform duration-500 w-48 h-72 md:w-64 md:h-[27.75rem] mx-auto">
				{/* Libro con sombra y profundidad */}
				<div className="relative bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 w-full h-full">
					{/* Portada del libro - Tamaños fijos con aspect ratio correcto */}
					<Image
						src="/assets/book.jpg"
						alt="Todo lo que no ves - Aránzazu G. Butler"
						fill
						className="object-cover"
						priority
					/>

					{/* Lomo del libro */}
					<div className="absolute -right-1 top-0 bottom-0 w-2 bg-gray-300 transform rotate-y-12"></div>
				</div>

				{/* Sombra del libro */}
				<div className="absolute -bottom-4 left-4 right-4 h-4 bg-black/20 rounded-full blur-md"></div>
			</div>

			{/* Información adicional del libro */}
			{showInfo && (
				<motion.div
					initial={{ opacity: 0, y: prefersReducedMotion ? 0 : 10 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.6, delay: 0.8 }}
					className="mt-6 text-center space-y-2"
				>
					<p className="text-sm text-gray-600">141 páginas • Edición Kindle</p>
					<p className="text-xs text-gray-500">Publicado: Mayo 2025</p>
					{/* Link a Amazon */}
					{showAmazonLink && (
						<Link
							href={amazonUrl}
							target="_blank"
							rel="noopener noreferrer"
							className="group inline-flex items-center gap-2 text-sm font-bold transition-colors duration-200 bg-white border border-black hover:border-orange-500 hover:bg-orange-500 text-black hover:text-white px-4 py-2 rounded-full"
						>
							<IconBrandAmazon className="w-4 h-4 text-orange-500 group-hover:text-white transition-colors duration-200" />
							Ver en Amazon
						</Link>
					)}
				</motion.div>
			)}
		</div>
	);
}
